// extracted by mini-css-extract-plugin
module.exports = {"box":"LoanSizeConstraints_box__1ZXNj","content":"LoanSizeConstraints_content__35Wgu"};